import { computed, ref, watchEffect } from 'vue'
import { defineStore } from 'pinia'

type Theme = 'light' | 'dark'

const STORAGE_KEY = 'joja-theme'

const getInitialTheme = (): Theme => {
  if (typeof window === 'undefined') return 'light'
  const savedTheme = window.localStorage.getItem(STORAGE_KEY)
  if (savedTheme === 'light' || savedTheme === 'dark') return savedTheme
  return 'light'
}

export const useThemeStore = defineStore('theme', () => {
  const theme = ref<Theme>(getInitialTheme())
  const isDark = computed(() => theme.value === 'dark')

  const setTheme = (nextTheme: Theme) => {
    theme.value = nextTheme
  }

  const toggleTheme = () => {
    setTheme(isDark.value ? 'light' : 'dark')
  }

  watchEffect(() => {
    if (typeof document === 'undefined') return
    document.documentElement.dataset.theme = theme.value
    window.localStorage.setItem(STORAGE_KEY, theme.value)
  })

  return {
    theme,
    isDark,
    setTheme,
    toggleTheme,
  }
})
